module.exports = __webpack_public_path__ + "static/img/project_describe.b36bd193.png";